import { render, staticRenderFns } from "./saveStudentStory.vue?vue&type=template&id=e5cdd702&"
import script from "./saveStudentStory.vue?vue&type=script&lang=js&"
export * from "./saveStudentStory.vue?vue&type=script&lang=js&"
import style0 from "./saveStudentStory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports